<template>
  <div>
    <v-progress-linear
      v-if="isDocumentsTypeBusy"
      indeterminate
      rounded
      color="primary"
    ></v-progress-linear>
    <span>{{ name }}</span>
  </div>
</template>

<script>
import { documentTypeStoreData } from '../../../catalogs/store/documentTypeStoreHelpers'

export default {
  name: 'DocumentDocumentType',
  props: {
    value: {
      type: String
    }
  },
  computed: {
    ...documentTypeStoreData,
    name() {
      let doc = this.documentsType.find(d => d.idTipoDocumento == this.value)
      return doc ? doc.nombre : ''
    }
  }
}
</script>